// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"0e80a1e2","171":"cc877e9c","374":"e38a78a0","432":"07f94dca","446":"ee5ff5e5","453":"3852b6ae","507":"f45f005f","520":"87b85b05","923":"1f1681c7"}[chunkId] + ".chunk.js";
};